<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/inscription/list' }">
        <app-i18n code="entities.inscription.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.inscription.importer.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.inscription.importer.title"></app-i18n>
      </h1>

      <app-importer storePath="inscription/importer"></app-importer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-inscription-importer-page',
};
</script>

<style>
</style>
